import UserSelectProvider from 'components/CIMSSelect/common/UserSelect/UserSelectContext'
import { DisciplinesTable } from './components/DisciplinesTable'
import { DisciplinesTableProvider } from './DisciplinesTableContext'

export const Disciplines: React.FC = () => (
  <DisciplinesTableProvider>
    <UserSelectProvider>
      <DisciplinesTable />
    </UserSelectProvider>
  </DisciplinesTableProvider>
)
